<template>
    <div class="flex flex-col justify-center items-center py-6 lg:py-12">
        <div>© 2021 - {{curYear}} 轻熵科技 版权所有</div>
        <div><a-button type="link" href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备2022002998号-1</a-button>成都轻熵科技有限责任公司</div>
    </div>
</template>

<script>
export default {
    name: 'homePageFooter',
    data() {
        return {
            curYear: new Date().getFullYear()
        }
    }
}
</script>
